// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"5078dcd6","136":"350e38af","142":"08d45f9d","312":"593156ef","428":"a15f5ff9","646":"b97ed11a","709":"a089beb0"}[chunkId] + ".chunk.js";
};